exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-container[data-v-e7ba80a0] {\n  position: relative;\n  margin: auto;\n}\n.overlay[data-v-e7ba80a0] {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 11;\n  background-color: rgba(0, 0, 0, 0.3);\n  pointer-events: none;\n  text-align: center;\n}\n.overlay__text[data-v-e7ba80a0] {\n  color: white;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-style: italic;\n  font-size: 10vw;\n  line-height: 100%;\n}\n@media screen and (min-width: 768px) {\n.overlay__text[data-v-e7ba80a0] {\n    font-size: 4vw;\n}\n}", ""]);

// exports
